
<div>
  <h4 class="mb-2">E-Mail to Board</h4>

  <div v-if="!email2BoardSettings.length">
    There is no E-Mail to Board setting for this board available. Please contact your administrator.
  </div>

  <table class="table table-sm" v-else>
    <colgroup>
      <col style="width: 25%" />
      <col style="width: 40%" />
    </colgroup>
    <thead>
      <tr>
        <th>Configured E-Mail Address</th>
        <th>Board Item Type for new Items</th>
        <th class="text-center">Enabled</th>
        <th>Processed E-Mails</th>
        <th>Last Check</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="setting in email2BoardSettings" :key="setting.email">
        <td style="vertical-align: middle">{{ setting.email }}</td>
        <td>
          <grouped-select
            :options="availableBoardCategories"
            v-model="setting.boardItemTypeGuid"
          ></grouped-select>
        </td>
        <td style="vertical-align: middle;text-align: center"><i class="far fa-check" v-if="setting.isEnabled"></i><i class="far fa-times" v-else></i></td>
        <td style="vertical-align: middle">{{setting.successfulImports}}</td>
        <td style="vertical-align: middle">{{setting.lastSync}}</td>
      </tr>
    </tbody>
  </table>

  <hr />

  <div class="d-flex justify-content-end">
    <button class="btn btn-save btn-sm btn-success" @click="save()">
      <i class="far fa-save"></i>
      Save changes
    </button>
  </div>
</div>
